import { getStore } from '../../helpers/initStore.js';

const applyFeatureFlagOverrides = (featureFlags, featureFlagOverrides) => ({ ...featureFlags, ...featureFlagOverrides });
const getIsDebugMode = () => !!getStore().state.variables.featureFlags.debug;
/**
 * Returns true if the fulfillment integration is enabled for the given type.
 *
 * @param integrationName - The name of the integration.
 * @param type - The type of the integration.
 * @returns True if the integration is enabled for the given type, false otherwise.
 */
const getIsFulfillmentIntegrationEnabled = (integrationName, type) => {
    var _a, _b;
    const { fulfillmentIntegrations } = (_a = getStore().state.variables.variables) !== null && _a !== void 0 ? _a : {};
    if (!fulfillmentIntegrations)
        return false;
    return !!((_b = fulfillmentIntegrations[integrationName][type]) === null || _b === void 0 ? void 0 : _b.enabled);
};

export { applyFeatureFlagOverrides, getIsDebugMode, getIsFulfillmentIntegrationEnabled };
